import reducer from './reducers';

export { default as permissionsActions } from './actions';

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/permissions/index.js